//#region src/Splitter/utils/constants.ts
const PRECISION = 10;

//#endregion
export { PRECISION };
//# sourceMappingURL=constants.js.map